export default "__VITE_ASSET__CgPTPKK3__"